var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCandadoCerrado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 225 225",
    style: {
      enableBackground: "new 0 0 225 225"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DFE0E0;}\r\n\t.st1{fill:#EAEAEA;}\r\n\t.st2{fill:#999999;}\r\n\t.st3{opacity:8.000000e-02;}\r\n\t.st4{fill:url(#Uni\xF3n_3_00000047023157594744658380000017452073749179892635_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-escudo",
    transform: "translate(-32.219 -43.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8985",
    transform: "translate(32.219 43.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5907",
    className: "st0",
    d: "M37.2,15.9v26.2L5.5,49.3c-1.7,0.4-3,1.9-3,3.7v52.7c0,45.4,28.7,86.1,72.3,102.5 l37.7,14.3V2.5l-72,9.7C38.6,12.4,37.2,14,37.2,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5908",
    className: "st1",
    d: "M112.5,222.5l37.7-14.3c43.6-16.5,72.3-57.2,72.3-102.5V53c0-1.8-1.3-3.3-3-3.7l-31.7-7.2 V15.9c0-1.9-1.5-3.5-3.4-3.7l-72-9.7L112.5,222.5z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-candado-cerrado",
    className: "st2",
    d: "M112.8,38.2c-36.5,0-66,29.5-66,66s29.5,66,66,66s66-29.5,66-66 S149.2,38.2,112.8,38.2z M142.3,133.5c0,4.6-3.7,8.4-8.3,8.4l0,0H92.1c-4.6,0-8.4-3.7-8.4-8.4l0,0v-27.8c0-4.6,3.7-8.4,8.3-8.4l0,0 v-9.8c0-11.5,9.3-20.9,20.9-20.9c11.5,0,20.9,9.3,20.9,20.9l0,0v9.8c4.6,0,8.4,3.8,8.4,8.4L142.3,133.5z M112.5,75 c-6.9,0-12.5,5.6-12.5,12.5v9.8h25.1v-9.7C125.1,80.6,119.5,75,112.5,75L112.5,75z M113.2,110.4c-3.4-0.2-6.4,2.4-6.6,5.9 c-0.1,2.2,0.9,4.3,2.7,5.5c1,0.7,1.4,1.9,1,3c-0.1,0.3-0.2,0.9-0.3,1.2c-0.5,1.6,0.7,4,2.4,4h0.5c1.7,0,2.9-2.4,2.4-4 c-0.1-0.3-0.2-1.4-0.3-1.7c-0.3-1,0-2.1,0.9-2.8c2.3-1.3,3.5-4,2.8-6.6C118,112.4,115.8,110.6,113.2,110.4L113.2,110.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9065",
    transform: "translate(-1281 2278.157)",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8985-2",
    transform: "translate(0 70.999)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Uni\\xF3n_3_00000129924692782570030710000005269954295927967142_",
    gradientUnits: "userSpaceOnUse",
    x1: 1136.295,
    y1: -1979.8279,
    x2: 1136.295,
    y2: -1981.4377,
    gradientTransform: "matrix(109.998 0 0 -60 -123596.6875 -121014.9453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.102
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_3",
    style: {
      fill: "url(#Uni\xF3n_3_00000129924692782570030710000005269954295927967142_)"
    },
    d: "M1356.1-2136.4 c-42.9-8.8-71.1-30.6-71.1-54.9v-25.5c0-3.5,4.6-6.6,11.1-7.4l19.6-2.4v-8.1c0-3.8,5.3-7,12.4-7.5l65.3-4.8l0,0l65.4,4.8 c7.1,0.5,12.4,3.7,12.4,7.5v8.1l19.6,2.4c6.5,0.8,11.1,3.9,11.1,7.4v25.5c0,24.3-28.2,46.1-71.1,54.9l-37.4,7.7l0,0L1356.1-2136.4 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCandadoCerrado);
export default __webpack_public_path__ + "static/media/ico-candado-cerrado.941123d5ac927b1c22a67192f2935f7f.svg";
export { ForwardRef as ReactComponent };